import { DEFAULT_TRIM_PROFILE_DESCRIPTOR } from "building-types/profiles/defaultBoardTrimProfiles";
import type { ProfileExtrusionDescriptor, ProfileTable } from "building-types/profiles/profileTypes";

export function queryProfileDescriptor(
  profileTable: ProfileTable,
  profileId: string | undefined,
  settingsToCatalogs: boolean | undefined,
): ProfileExtrusionDescriptor | undefined {
  if (profileId && profileTable[profileId]) {
    return profileTable[profileId];
  }
  if (!settingsToCatalogs) {
    return DEFAULT_TRIM_PROFILE_DESCRIPTOR;
  }
  return undefined;
}
